import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class BiTolService extends ServiceCRUD {
  private baseUrlService: string;

  constructor(public httpClient: HttpClient, router: Router) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
    })
  };

  protected getURL(): string {
    return `${this.baseUrlService}/rmpv/detalhado`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealer?: any,
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/tol'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealer', dealer.toString())
    });
  }

  public getDadosAnaliticos(
    codigo?: any,
    data_inicial?: any,
    data_final?: any,
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/tol/analitico/' + codigo.toString()}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
    });
  }

  public getDadosBloqueados(
    codigo?: any,
    data_inicial?: any,
    data_final?: any,
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/tol/bloqueados/' + codigo.toString()}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
    });
  }

}
